"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalizationPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.PersonalizationPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Personalization: 'PERSONALIZATION',
});
//# sourceMappingURL=personalization.js.map